/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 49a830b3 (Tue Jan 27 16:18:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  LicensingPayments,
  LicensingPaymentsFromJSON,
  LicensingPaymentsToJSON,
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchLicensingLcdPaymentsResponse
 */
export interface FetchLicensingLcdPaymentsResponse {
  /**
   *
   * @type {Array<LicensingPayments>}
   * @memberof FetchLicensingLcdPaymentsResponse
   */
  data: Array<LicensingPayments>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchLicensingLcdPaymentsResponse
   */
  pagination?: PaginationResponse
}

export function FetchLicensingLcdPaymentsResponseFromJSON(
  json: any
): FetchLicensingLcdPaymentsResponse {
  return FetchLicensingLcdPaymentsResponseFromJSONTyped(json, false)
}

export function FetchLicensingLcdPaymentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLicensingLcdPaymentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(LicensingPaymentsFromJSON),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchLicensingLcdPaymentsResponseToJSON(
  value?: FetchLicensingLcdPaymentsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(LicensingPaymentsToJSON),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
